import { utilTypes } from "../types";

export const getAllThemes = (data) => {
  return {
    type: utilTypes.GET_ALL_THEMES,
    payload: {
      request: {
        url: "/theme/all",
        method: "get",
      },
    },
  };
};

export const toggleDrawer = () => {
  return {
    type: utilTypes.TOGGLE_DRAWER,
  };
};
export const toggleAdvertisement = () => {
  return {
    type: utilTypes.TOGGLE_ADVERTISEMENT,
  };
};

export const openCommonPageModal = (data) => {
  return {
    type: utilTypes.OPEN_COMMON_PAGE_MODAL,
    payload: data,
  };
};

export const closeCommonPageModal = (data) => {
  return {
    type: utilTypes.CLOSE_COMMON_PAGE_MODAL,
  };
};

export const setCurrentGram = (id) => {
  return {
    type: utilTypes.SET_CURRENT_GRAM,
    payload: id,
  };
};
